<template>
    <div class="mrt20">
        <el-row>
            <el-col :span="4">
                <div>
                    <el-table
                            height="940"
                            :data="gsData"
                            style="width: 100%"
                            @row-click="gsrowClick"
                            :header-cell-style="{background:'#eef1f6',color:'#000'}"
                            :highlight-current-row="highlightCurrentRow">
                        <el-table-column
                                prop="vc_name"
                                :label="$t('form_entrust_company')">
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
            <el-col :span="20">
                <template>
                    <el-tabs type="border-card" @tab-click="dataListClick" >
                        <el-tab-pane  label="来料入库" >
                            <div v-if="tabIndex == '0'">
                                <div class="mrl20">
                                    <el-button type="primary" class="mrt10" :class="baseerp+'btn'" @click="addData" size="mini">添加</el-button>
                                    <el-table
                                            class="mrt20"
                                            :data="tableData"
                                            style="width: 100%"
                                            max-height="900"
                                            height="810"
                                            :header-cell-style="{background:'#eef1f6',color:'#000'}">
                                        <el-table-column
                                                prop="pid"
                                                label="ID"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_pmname"
                                                :label="$t('form_product_name')"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_no"
                                                label="库号"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_num"
                                                label="申请数量"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_num"
                                                label="确认数量"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_unit"
                                                :label="$t('form_metering')"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="dt_createtime"
                                                label="申请日期"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_lruname"
                                                label="录入人"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_processCompany"
                                                label="加工公司"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_entrustCompany"
                                                :label="$t('form_entrust_company')"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_ckName"
                                                :label="$t('form_warehouse')"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                fixed="right"
                                                label="操作"
                                                width="50">
                                            <template slot-scope="scope">
                                                <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!--分页-->
                                    <div>
                                        <el-pagination
                                                background
                                                style="color: #e8c984"
                                                class="fr page "
                                                layout="prev, pager, next"
                                                @current-change="pageCurrentChange"
                                                :current-page.sync="currentPage"
                                                :total="tableTotal"
                                                :page-size="pageSize">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane  label="生产产出">
                            <div v-if="tabIndex == '1'">
                                <div class="mrl20">
                                    <!--头部-->
                                    <div class="choosedate mrl20 mrt20">
                                        <span class="mrt10">选择生产录入日期:</span>
                                        <el-date-picker
                                                v-model="begin_time"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                type="date"
                                                placeholder="选择日期">
                                        </el-date-picker>
                                        <span class="mrt10">至</span>
                                        <el-date-picker
                                                v-model="end_time"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                type="date"
                                                placeholder="选择日期">
                                        </el-date-picker>
                                        <el-input class="mrl20" style="width: 15%" v-model="vcNo" placeholder="请输入生产批次号" clearable></el-input>
                                        <el-button class="mrl20" icon="el-icon-search" circle @click="proSearch"></el-button>
                                    </div>
                                    <el-button type="primary" class="mrt10 mrl20" :class="baseerp+'btn'" @click="batchpayment">批量提交</el-button>
                                    <el-table
                                            class="mrt20"
                                            :data="productData"
                                            style="width: 100%"
                                            max-height="900"
                                            height="810"
                                            :header-cell-style="{background:'#eef1f6',color:'#000'}"
                                            @select="selectChange"
                                            ref="mulTable"
                                            @select-all="selectAll"
                                            >
                                        <el-table-column
                                                type="selection"
                                                width="55"
                                                :selectable="isDisabled">
                                        </el-table-column>
                                        <el-table-column
                                                prop="i_id"
                                                :label="$t('form_serial_number')"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_pzname"
                                                :label="$t('form_finished_goods')"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_no"
                                                label="生产批次号"
                                                width="100"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_unit"
                                                :label="$t('form_metering')"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_outnum"
                                                :label="$t('promanagement_output_quantity')"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="kysl"
                                                label="已入库量"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_bc"
                                                label="班次"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_scxname"
                                                label="生产线"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="dt_lrcreatetime"
                                                label="录入时间"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_lruname"
                                                label="录入人"
                                                width="80"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_state"
                                                label="状态"
                                                width="80"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="dt_jfcreatetime"
                                                label="交付时间"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_jfuname"
                                                label="交付人"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_jgmoney"
                                                label="加工费"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_note"
                                                :label="$t('form_notes')"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                fixed="right"
                                                label="操作"
                                                width="80">
                                            <template slot-scope="scope">
                                                <el-button @click="productClick(scope.row)" type="text" size="small" v-if="scope.row.i_state==0||scope.row.i_state==-1" :disabled="scope.row.f_outnum==scope.row.kysl?false:true">提交</el-button>
                                                <el-button @click="productWatchClick(scope.row)" type="text" size="small" v-else >查看</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!--分页-->
                                    <div>
                                        <el-pagination
                                                background
                                                style="color: #e8c984"
                                                class="fr page "
                                                layout="prev, pager, next"
                                                @current-change="proPageCurrentChange"
                                                :current-page.sync="proCurrentPage"
                                                :total="proTableTotal"
                                                :page-size="proPageSize">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane  label="审核中">
                            <div v-if="tabIndex == '2'">
                                <div class="mrl20">
                                    <!--头部-->
                                    <div class="choosedate mrl20 mrt20">
                                        <span class="mrt10">选择审核日期:</span>
                                        <el-date-picker
                                                v-model="examinebegin_time"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                type="date"
                                                placeholder="选择日期">
                                        </el-date-picker>
                                        <span class="mrt10">至</span>
                                        <el-date-picker
                                                v-model="examineend_time"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                type="date"
                                                placeholder="选择日期">
                                        </el-date-picker>
                                        <el-input class="mrl20" style="width: 15%" v-model="examinevcNo" placeholder="请输入生产批次号" clearable></el-input>
                                        <el-button class="mrl20" icon="el-icon-search" circle @click="examineSearch"></el-button>
                                    </div>
                                    <el-table
                                            class="mrt20"
                                            :data="examineData"
                                            style="width: 100%"
                                            max-height="900"
                                            height="810"
                                            :header-cell-style="{background:'#eef1f6',color:'#000'}">
                                        <el-table-column
                                                prop="i_outid"
                                                :label="$t('form_serial_number')"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_pzname"
                                                :label="$t('form_finished_goods')"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_no"
                                                label="生产批次号"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_unit"
                                                :label="$t('form_metering')">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_num"
                                                :label="$t('form_delivery_quantity')">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_state"
                                                label="状态">
                                        </el-table-column>
                                        <el-table-column
                                                prop="dt_jfcreatetime"
                                                label="审核时间"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_jfuname"
                                                label="交付人">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_jgmoney"
                                                label="加工费"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_note"
                                                :label="$t('form_notes')"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                fixed="right"
                                                label="操作"
                                                width="80">
                                            <template slot-scope="scope">
                                                <el-button @click="examineClick(scope.row)" type="text" size="small" v-if="scope.row.i_state==3">审核</el-button>
                                                <el-button @click="examineWatchClick(scope.row)" type="text" size="small" v-else>查看</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!--分页-->
                                    <div>
                                        <el-pagination
                                                background
                                                style="color: #e8c984"
                                                class="fr page"
                                                layout="prev, pager, next"
                                                @current-change="examinePageCurrentChange"
                                                :current-page.sync="examineCurrentPage"
                                                :total="examineTableTotal"
                                                :page-size="examinePageSize">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane  label="交付">
                            <div v-if="tabIndex == '3'">
                                <div class="mrl20">
                                    <!--头部-->
                                    <div class="choosedate mrl20 mrt20">
                                        <span class="mrt10">选择交付日期:</span>
                                        <el-date-picker
                                                v-model="paymentbegin_time"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                type="date"
                                                placeholder="选择日期">
                                        </el-date-picker>
                                        <span class="mrt10">至</span>
                                        <el-date-picker
                                                v-model="paymentend_time"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                type="date"
                                                placeholder="选择日期">
                                        </el-date-picker>
                                        <el-input class="mrl20" style="width: 15%" v-model="paymentvcNo" placeholder="请输入生产批次号" clearable></el-input>
                                        <el-button class="mrl20" icon="el-icon-search" circle @click="paymentSearch"></el-button>
                                    </div>
<!--                                    <el-button type="primary" class="mrt10 mrl20" :class="baseerp+'btn'" @click="batchpayment">批量交付</el-button>-->
                                    <el-table
                                            class="mrt20"
                                            :data="paymentData"
                                            style="width: 100%"
                                            max-height="900"
                                            height="810"
                                            :header-cell-style="{background:'#eef1f6',color:'#000'}">
<!--                                        <el-table-column-->
<!--                                                type="selection"-->
<!--                                                width="55"-->
<!--                                                :selectable="isDisabled">-->
<!--                                        </el-table-column>-->
                                        <el-table-column
                                                prop="i_outid"
                                                :label="$t('form_serial_number')"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_pzname"
                                                :label="$t('form_finished_goods')"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_no"
                                                label="生产批次号"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_unit"
                                                :label="$t('form_metering')">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_num"
                                                :label="$t('form_delivery_quantity')">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_state"
                                                label="状态">
                                        </el-table-column>
                                        <el-table-column
                                                prop="dt_jfcreatetime"
                                                label="交付时间"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_jfuname"
                                                label="交付人">
                                        </el-table-column>
                                        <el-table-column
                                                prop="f_jgmoney"
                                                label="加工费"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                prop="vc_note"
                                                :label="$t('form_notes')"
                                                width="80">
                                        </el-table-column>
                                        <el-table-column
                                                fixed="right"
                                                label="操作"
                                                width="80">
                                            <template slot-scope="scope">
                                                <el-button @click="paymentWatchClick(scope.row)" type="text" size="small" v-if="scope.row.i_state_mq==1">查看</el-button>
                                                <el-button @click="paymentClick(scope.row)" type="text" size="small" v-else>交付</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!--分页-->
                                    <div>
                                        <el-pagination
                                                background
                                                style="color: #e8c984"
                                                class="fr page "
                                                layout="prev, pager, next"
                                                @current-change="paymentPageCurrentChange"
                                                :current-page.sync="paymentCurrentPage"
                                                :total="paymentTableTotal"
                                                :page-size="paymentPageSize">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </template>
            </el-col>
        </el-row>
        <!--dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                     width="1000px"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
                <warehouse-form :warehouse="warehouse" @close="cancelDialog" @getEntrustCompanyHaveList="getEntrustCompanyHaveList"></warehouse-form>
            </el-dialog>
        </div>
        <!--生产产出dialog-->
<!--        <div :class="baseerp+'div'">-->
<!--            <el-dialog-->
<!--                     width="1000px"-->
<!--                    :title="producttitle"-->
<!--                    :visible.sync="productdialogVisible"-->
<!--                    :close-on-click-modal="false"-->
<!--                    @close="cancelProDialog"-->
<!--                    v-if="productdialogVisible">-->
<!--                <deliver-form :deliver="deliver" @close="cancelProDialog" @getProduceList="getProduceList"></deliver-form>-->
<!--            </el-dialog>-->
<!--        </div>-->
        <!--审核dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                     width="1000px"
                    :title="examinetitle"
                    :visible.sync="examinedialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelExamineDialog"
                    v-if="examinedialogVisible">
                <review-form :review="review" @close="cancelExamineDialog" @exagetProduceOutList="exagetProduceOutList"></review-form>
            </el-dialog>
        </div>
        <!--交付dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                     width="1000px"
                    :title="paymenttitle"
                    :visible.sync="paymentdialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelRenderDialog"
                    v-if="paymentdialogVisible">
                <render-form :render="render" @close="cancelRenderDialog" @paygetProduceOutList="paygetProduceOutList"  @getProduceList="getProduceList"></render-form>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import * as API from "./api";
    import axios from "axios";
    import WarehouseForm from "./components/WarehouseForm";
    import DeliverForm from "./components/DeliverForm";
    import RenderForm from "./components/RenderForm";
    import ReviewForm from "./components/ReviewForm";
    import {baseerp} from "@/utils/baseUrl";
    import {mapActions} from "vuex";
    export default {
        name:"wareHousingApp",
        components:{WarehouseForm,DeliverForm,RenderForm,ReviewForm},

        data(){
            return{
                //交付
                paymentData:[],
                paymentCurrentPage:1,
                paymentTableTotal:0,
                paymentPageSize:13,
                paymentbegin_time:"",
                paymentend_time:"",
                paymentvcNo:"",
                render:{},
                paymenttitle:"",
                paymentdialogVisible:false,
                secRow:"",
                batchData:"",

                //审核
                examineData:[],
                examineCurrentPage:1,
                examineTableTotal:0,
                examinePageSize:13,
                examinebegin_time:"",
                examineend_time:"",
                examinevcNo:"",
                review:{},
                examinedialogVisible:false,
                examinetitle:"",

                //产品产出
                productData:[],
                producttitle:"",
                productdialogVisible:false,
                proPageSize:13,
                proCurrentPage:1,
                proTableTotal:0,
                vcNo:"",
                begin_time:"",
                end_time:"",
                deliver:{},

                //来料入库
                tabIndex:0,
                dataList:true,
                activeName:"first",
                id:"",
                vcname:"",
                warehouse:{},
                title:"",
                dialogVisible:false,
                gsData:[],
                tableData:[],
                highlightCurrentRow:false,
                pageSize:13,
                currentPage:1,
                tableTotal:0,
                baseerp:"",
                mid:0,

                // disabled:false,
            }
        },

        mounted() {
            this.baseerp=baseerp;
            //调用公司接口
            this.getCompanyList();

        },

        methods:{
            ...mapActions(["getCurrentMenuId"]),
            //批量交付
            batchpayment(){
                if (this.batchData!=""){
                    this.paymentdialogVisible=true;
                    this.paymenttitle="批量提交单";
                    // console.log(this.batchData,"this.batchData");
                    this.render={
                        title:"批量提交单",
                        value:this.batchData,
                    };
                    // console.log(this.render,"this.render")
                }else{
                    this.$message.error("请选择提交产品");
                }

            },

            selectAll () {
                this.$nextTick(()=>{
                    this.$refs.mulTable.clearSelection()
                });
            },

            isDisabled(row) {
                // 通过true和false控制是否禁用，true: 不禁用，false：禁用
                if (row.f_outnum!=row.kysl){
                    if(this.secRow.vc_pzname!=row.vc_pzname){
                        return false
                    }
                }else{
                    return true;
                }

                // if (this.secRow!=''){
                //     if (this.secRow.vc_pzname!=row.vc_pzname) {
                //         return false
                //     } else {
                //         return true
                //     }
                // }else if (row.f_outnum!=row.kysl){
                //     return false
                // }else{
                //     return true
                // }
            },

            //拿到当前行 selection是数组，row是拿到当前行
            selectChange(selection, row) {
                // console.log(selection,row,"拿到当前行");
                if (selection.length==0){
                    this.secRow='';
                    this.batchData="";
                }else {
                    this.secRow=row;
                    this.batchData=selection;
                }

            },


            //关闭交付表
            cancelRenderDialog(){
                this.paymentdialogVisible=false
            },

            //关闭审核表
            cancelExamineDialog(){
                this.examinedialogVisible=false
            },

            //审核接口(i_type=0)
            async exagetProduceOutList(){
                let param= {
                    i_mid: this.mid,
                    i_gsid: this.id,
                    vc_no:this.examinevcNo,
                    begin_time: this.examinebegin_time,
                    end_time:this.examineend_time,
                    i_type: 0,
                    page_size:this.examineCurrentPage,
                    page_count:13,
                };
                let res=await API.getProduceOutList(param);
                if (res.code==1){
                    this.examineData=res.data;
                    this.examineTableTotal=res.count;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //交付接口(i_type=1)
            async paygetProduceOutList(){
                let param={
                    i_mid: this.mid,
                    i_gsid:this.id,
                    vc_no:this.paymentvcNo,
                    begin_time:this.paymentbegin_time,
                    end_time:this.paymentend_time,
                    i_type:1,
                    page_size:this.examineCurrentPage,
                    page_count:13,
                };
                let res=await API.getProduceOutList(param);
                if (res.code==1){
                    this.paymentData=res.data;
                    this.paymentTableTotal=res.count;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },


            //查看已交付当前行数据
            paymentWatchClick(row){
                this.paymenttitle="查看交付单";
                this.render={
                    page_size:this.paymentCurrentPage,
                    title:"查看交付单",
                    value:row,
                    i_mid:this.mid,
                };
                // console.log(this.render,"render查看交付单");
                this.paymentdialogVisible=true;
            },

            //未交付当前行数据点击交付
            paymentClick(row){
                this.paymenttitle="提交交付单";
                this.render={
                    page_size:this.paymentCurrentPage,
                    title:"提交交付单",
                    value:row,
                    i_mid:this.mid,
                };
                // console.log(this.render,"render提交交付单");
                this.paymentdialogVisible=true;
            },

            //查看审核当前行数据
            examineWatchClick(row){
                this.examinetitle="查看审核表";
                this.review={
                    page_size:this.examineCurrentPage,
                    title:"查看审核表",
                    value:row,
                    i_mid:this.mid,
                };
                this.examinedialogVisible=true;
            },

            //审核当前行数据
            examineClick(row){
                this.examinetitle="确认审核表";
                this.review={
                    page_size:this.examineCurrentPage,
                    title:"确认审核表",
                    value:row,
                    i_mid:this.mid,
                };
                this.examinedialogVisible=true;
            },

            //产品产出接口
            async getProduceList(val){
                if(val!=undefined) {
                    //console.log(gsval,"addddd")
                    this.id=val.wtgsid;
                    this.proCurrentPage=val.pageSize;
                }
                let param = {
                    i_mid: this.mid,
                    i_gsid:this.id,
                    vc_no:this.vcNo,
                    page_size:this.proCurrentPage,
                    page_count:13,
                    begin_time: this.begin_time,
                    end_time: this.end_time,
                };
                let res = await API.getProduceList(param);
                if (res.code == 1) {
                    this.productData=res.data;
                    this.proTableTotal=res.count;
                    //console.log(this.productData,this.productData,"this.productData");
                    //this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //产品产出查询
            proSearch(){
                ///调用产品产出列表
                this.getProduceList();
            },

            //产品审核查询
            examineSearch(){
                ///调用审核列表接口
                this.exagetProduceOutList();
            },

            //产品交付查询
            paymentSearch(){
                ///调用交付列表接口
                this.paygetProduceOutList();
            },

            //产品产出当前行数据(交付)
            productClick(row){
                //console.log(row,"productRow");
                this.render={
                    page_size:this.proCurrentPage,
                    title:"产品提交",
                    value:row,
                    i_mid:this.mid,
                };
                // console.log(this.render,"this.deliver");
                this.paymenttitle="产品提交";
                this.paymentdialogVisible=true;
                this.highlightCurrentRow=true;
            },

            //产品产出当前行数据()
            productWatchClick(row){
                //console.log(row,"productwatchrow")
                this.render={
                    page_size:this.proCurrentPage,
                    title:"产品查看",
                    value:row,
                    i_mid:this.mid
                };
                // console.log(this.render,"this.deliver");
                this.paymenttitle="产品查看";
                this.paymentdialogVisible=true;
                this.highlightCurrentRow=true;
            },

            //产品产出
            cancelProDialog(){
                this.paymentdialogVisible=false;
            },

            //选项框
            dataListClick(tab) {
                //console.log(tab,"tabtabtabtab");
                this.tabIndex = tab.index;
                if (this.id!==""&&this.tabIndex==0){
                    this.getEntrustCompanyHaveList();
                }else if (this.id!==""&&this.tabIndex==1){
                    ///调用产品产出列表接口
                    this.getProduceList();
                }else if (this.id!==""&&this.tabIndex==2){
                    ///调用审核列表接口
                    this.exagetProduceOutList();
                }else if (this.id!==""&&this.tabIndex==3){
                    ///调用交付列表接口
                    this.paygetProduceOutList();
                }
            },

            //关闭dialog
            cancelDialog(){
                this.dialogVisible=false;
                this.highlightCurrentRow=true;
            },

            //公司接口
            async getCompanyList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    i_mid: this.mid,
                    i_type:1,
                };
                let res=await API.getCompanyList(param);
                if(res.code==1){
                    this.gsData=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },

            //拿到当前行公司数据
            gsrowClick(gsrow) {
                //console.log(gsrow,'gsrow');
                this.highlightCurrentRow=true;
                this.id=gsrow.i_id;
                this.vcname=gsrow.vc_name;
                if (this.tabIndex==0){
                    this.getEntrustCompanyHaveList();
                }else if (this.tabIndex==1){
                    this.getProduceList();
                }else if (this.tabIndex==2){
                    ///调用审核列表接口
                    this.exagetProduceOutList();
                }else if (this.tabIndex==3){
                    ///调用交付列表接口
                    this.paygetProduceOutList();
                }

            },

            //列表接口
            // getlist(){
            //     const that=this;
            //     axios.get("./requestlist.json").then(function (res) {
            //         console.log(res.data,"getlist");
            //         that.tableData=res.data;
            //     })
            // },
            async getEntrustCompanyHaveList(gsval){
                if(gsval!=undefined) {
                    //console.log(gsval,"addddd")
                    this.id=gsval;
                }
                let param = {
                    i_mid: this.mid,
                    i_id:this.id,
                    page_size:this.currentPage,
                    page_count:13,
                };
                let res = await API.getEntrustCompanyHaveList(param);
                if (res.code == 1) {
                    this.tableData=res.data;
                    this.tableTotal=res.count;
                    //console.log(this.tableData,this.tableTotal,"this.tableData");
                    //this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //点击添加
            addData(){
                this.title="添加入库申请单";
                this.highlightCurrentRow=true;
                if (this.id==""||this.id==undefined){
                    this.dialogVisible=false;
                    this.$message.error("请选择要添加的公司！")
                }else{
                    this.warehouse={
                        page_size:1,
                        i_id:this.id,
                        vc_name:this.vcname,
                        pid:0,
                        i_mid:this.mid,
                    };
                    this.dialogVisible=true;
                }
            },　

            //大列表里的查看
            handleClick(row) {
                //console.log(row,"row");
                this.title="查看入库申请单";
                this.highlightCurrentRow=false;
                this.warehouse={
                    pid:row.pid,
                    i_id:this.id,
                    vc_name:this.vcname,
                    i_mid:this.mid,
                };
                //console.log(this.warehouse,"watchData");
                this.dialogVisible=true;
            },

            //点击分页
            pageCurrentChange(val){
                //console.log(val,"pageval");
                this.currentPage=val;
                ///调用列表接口
                this.getEntrustCompanyHaveList();
            },

            //点击产品产出分页
            proPageCurrentChange(val){
                // console.log(val,"productpageval");
                this.proCurrentPage=val;
                ///调用产品产出列表
                this.getProduceList();
            },

            examinePageCurrentChange(val){
                this.examineCurrentPage=val;
                ///调用审核列表接口
            },
            paymentPageCurrentChange(val){
                this.paymentCurrentPage=val;
                ///调用交付列表接口
            },

        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        justify-content: left;
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .cl{
        clear: both;
    }
    .mrt10{
        margin-top: 10px;
    }
    .mrt20{
        margin-top: 20px;
    }
    .mrt70{
        margin-top: 70px;
    }
    .mrt80{
        margin-top: 80px;
    }
    .mrl20{
        margin-left: 10px;
    }

    /deep/{
        .content{
            display: none;
        }
        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }


    }

    .page{
        padding: 25px 15px;
    }


    /*/deep/ {*/
    /*    .el-table__header-wrapper .el-checkbox {*/
    /*        display: none*/
    /*    }*/
    /*}*/




</style>